module.exports = __webpack_public_path__ + "static/NotoSans-Medium-042c7048a6576d28655dc3da08730c3e.woff2";